import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';

export const dashboardService = {
  earnings: () => axios.get(Pathes.Dashboard.earnings),
  happyBrands: () => axios.get(Pathes.Dashboard.happyBrands),
  messages: () => axios.get(Pathes.Dashboard.messages),
};
